import { Component, Output, EventEmitter, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogConfig,
  MatDialogRef
} from '@angular/material/dialog';
import { AuthService } from 'src/app/services/AuthService/auth.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { ModalAcessoRestritoComponent } from '../../saida-gate/modal-acesso-restrito/modal-acesso-restrito.component';
import { ModalAberturaCaixaComponent } from '../modal-abertura-caixa/modal-abertura-caixa.component';
import { ModalFechamentoCaixaComponent } from '../modal-fechamento-caixa/modal-fechamento-caixa.component';
import { SwalAlertService } from 'src/app/services/SwalAlertService/swalAlert.service';
import { ModalSuprimentosCaixaComponent } from '../modal-suprimentos-caixa/modal-suprimentos-caixa.component';
import { ModalSangriaCaixaComponent } from '../modal-sangria-caixa/modal-sangria-caixa.component';

@Component({
  selector: 'app-modal-acesso-restrito-caixa',
  templateUrl: './modal-acesso-restrito-caixa.component.html',
  styleUrls: ['./modal-acesso-restrito-caixa.component.scss']
})
export class ModalAcessoRestritoCaixaComponent {
  @Output() movimentacoesAtualizadas = new EventEmitter<void>();
  form: FormGroup;
  permissionToken: string = '';
  isLoading: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private authService: AuthService,
    public dialogRef: MatDialogRef<ModalAcessoRestritoComponent>,
    public dialog: MatDialog,
    public swalAlert: SwalAlertService
  ) {
    this.form = this.initForm();
  }

  initForm() {
    const form = this.fb.group({
      TX_MAIL_FUNC: this.fb.control('', {
        validators: [Validators.required]
      }),
      TX_SENH_FUNC: this.fb.control('', {
        validators: [Validators.required, Validators.minLength(5)]
      })
    });
    return form;
  }

  postLogin() {
    this.isLoading = true;
    const { TX_MAIL_FUNC, TX_SENH_FUNC } = this.form.value;
    this.authService.loginFunc(TX_MAIL_FUNC, TX_SENH_FUNC, true).subscribe({
      next: (res: any) => {
        this.permissionToken = res.Token;
        if (this.data.SANGRIA) {
          const perm = res.PermissoesList.find((x: any) => x.NU_TIPO_PERM === 26)?.FL_INCL;
          if (perm) {
            this.onAcessar();
            return;
          }
        }
        if (this.data.SUPRIMENTOS) {
          const perm = res.PermissoesList.find((x: any) => x.NU_TIPO_PERM === 27)?.FL_INCL;
          if (perm) {
            this.onAcessar();
            return;
          }
        }
        if (this.data.ABERTURA || this.data.FECHAMENTO) {
          const perm = res.PermissoesList.find((x: any) => x.NU_TIPO_PERM === 28)?.FL_INCL;
          if (perm) {
            this.onAcessar();
            return;
          }
        }
        this.swalAlert.showAlert(
          'Acesso Restrito',
          'Você não tem permissão para acessar essa funcionalidade',
          'warning',
          true,
          false,
          undefined,
          () => {
            this.dialogRef.close();
          }
        );
      },
      error: (err: any) => {},
      complete: () => {}
    });
  }

  onAcessar(): void {
    this.isLoading = true;
    this.openModalRespectivo();
    this.dialogRef.close();
  }

  onCancelar(): void {
    this.dialogRef.close();
  }

  openModalRespectivo(): void {
    const dialogConfig = new MatDialogConfig();
    const PK_CAIX = this.data.PK_CAIX;
    const ABERTURA = this.data.ABERTURA;
    const FECHAMENTO = this.data.FECHAMENTO;
    const SUPRIMENTOS = this.data.SUPRIMENTOS;
    const SANGRIA = this.data.SANGRIA;
    const PK_MOVM_CAIX = this.data.PK_MOVM_CAIX;
    const EDIT_ITEM = this.data.EDIT_ITEM;

    if (ABERTURA) {
      const dialogConfig = new MatDialogConfig();

      dialogConfig.width = '680px';
      dialogConfig.disableClose = true;
      dialogConfig.data = {
        PK_CAIX: PK_CAIX,
        PermissionToken: this.permissionToken,
        NU_TIPO_CAIX: this.data.NU_TIPO_CAIX
      };

      const dialogRef = this.dialog.open(
        ModalAberturaCaixaComponent,
        dialogConfig
      );

      dialogRef.afterClosed().subscribe(() => {
        this.dialogRef.close({ atualizarMovimentacoes: true });
      });
    }

    if (FECHAMENTO) {
      const dialogConfig = new MatDialogConfig();

      dialogConfig.width = '680px';
      dialogConfig.disableClose = true;
      dialogConfig.data = {
        PK_CAIX,
        PermissionToken: this.permissionToken,
        NU_TIPO_CAIX: this.data.NU_TIPO_CAIX
      };

      const dialogRef = this.dialog.open(
        ModalFechamentoCaixaComponent,
        dialogConfig
      );

      dialogRef.afterClosed().subscribe(() => {
        this.dialogRef.close({ atualizarMovimentacoes: true });
      });
    }

    if (SUPRIMENTOS) {
      const dialogConfig = new MatDialogConfig();

      dialogConfig.width = '680px';
      dialogConfig.disableClose = true;
      dialogConfig.data = {
        PK_CAIX,
        PK_MOVM_CAIX,
        EDIT_ITEM,
        PermissionToken: this.permissionToken
      };

      const dialogRef = this.dialog.open(
        ModalSuprimentosCaixaComponent,
        dialogConfig
      );

      dialogRef.afterClosed().subscribe(() => {
        this.dialogRef.close({ atualizarMovimentacoes: true });
      });
    }

    if (SANGRIA) {
      const dialogConfig = new MatDialogConfig();

      dialogConfig.width = '680px';
      dialogConfig.disableClose = true;
      dialogConfig.data = {
        PK_CAIX,
        PK_MOVM_CAIX,
        EDIT_ITEM,
        PermissionToken: this.permissionToken
      };

      const dialogRef = this.dialog.open(
        ModalSangriaCaixaComponent,
        dialogConfig
      );

      dialogRef.afterClosed().subscribe(() => {
        this.dialogRef.close({ atualizarMovimentacoes: true });
      });
    }
  }
}
